import React, { type SyntheticEvent } from 'react';

import qs from 'query-string';
import { type DOMNode, Element } from 'html-react-parser';
import { handleImagePath } from '@lucid/hooks';

import Image from '../../components/image/image';
import type { Lucid } from '../../types/types';

type Options = {
  onLoad?: (e: SyntheticEvent<HTMLImageElement>) => void;
};

const imageParser = (domNode: DOMNode, _index?: number, options?: Options) => {
  if (domNode instanceof Element && domNode.attribs && domNode.name === 'img') {
    const { src, alt, width } = domNode.attribs;
    const customCss = {} as { width?: string };

    if (width) {
      customCss.width = `${width}px`;
    }

    if (typeof src === 'string') {
      const imageSrc = qs.parseUrl(src);
      customCss.width = imageSrc.query?.width ? `${imageSrc.query?.width}px` : undefined;
    }

    const hasCustomStyles = width || customCss.width;

    return (
      <Image
        className={hasCustomStyles ? 'overwrite-css' : ''}
        css={customCss}
        imageAlt={alt || ''}
        imageSrc={handleImagePath({
          filename_disk: src,
        } as Lucid.Directus.Generated.Directus_Files)}
        loading="lazy"
        onLoad={options?.onLoad}
      />
    );
  }
};

export default imageParser;
